import React, { useEffect, useState } from "react";
const BlueTag = ({
  children,
  className = "",
  center = false,
  variant = "default",
}) => {
  const [isCentered, setIsCentered] = useState(false);
  useEffect(() => {
    const updateCenter = () => {
      if (typeof center === "boolean") {
        setIsCentered(center);
      } else if (typeof center === "number") {
        setIsCentered(window.innerWidth < center);
      } else if (typeof center === "object") {
        const [operator, value] = Object.entries(center)[0];
        if (operator === "<") setIsCentered(window.innerWidth < value);
        if (operator === ">") setIsCentered(window.innerWidth > value);
      }
    };
    updateCenter();
    window.addEventListener("resize", updateCenter);
    return () => window.removeEventListener("resize", updateCenter);
  }, [center]);

  const variants = {
    default: `text-custom-blue-v3 after:bg-custom-blue-v3 ${
      isCentered && "before:bg-custom-blue-v3"
    }`,
    white: `text-white after:bg-white ${isCentered && "before:bg-white"}`,
  };
  return (
    <p
      className={`${className} font-bold leading-none text-base max-md:text-xs uppercase relative after:absolute after:-right-3 after:top-1/2 after:-translate-y-1/2 after:h-0.5 after:w-16 inline-block after:translate-x-full  ${
        isCentered &&
        "before:absolute before:-left-3 before:top-1/2 before:-translate-y-1/2 before:h-0.5 before:w-16 inline-block before:-translate-x-full"
      } ${variants[variant]}`}>
      {children || "About Us"}
    </p>
  );
};

export default BlueTag;
